import { useTable, useFilters, useGlobalFilter, useSortBy } from "react-table";
import PropTypes from "prop-types";
import DataTable from "components/organisms/DataTable/DataTable";
import CardNew from "components/molecules/Card/CardNew";
import "./tableChart.scss";

function TableChart({ isLoading, columns, data }) {
  const instance = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
  );

  return (
    <CardNew className="mt-3 tablechart-container">
      <DataTable tableInstance={instance} isLoading={isLoading} withoutBody draggable={false} />
    </CardNew>
  );
}

TableChart.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  columns: PropTypes.instanceOf(Array).isRequired,
  data: PropTypes.instanceOf(Array).isRequired,
};

export default TableChart;
